module.exports = __webpack_public_path__ + "img/room4.11b8da87.png";